import { render, staticRenderFns } from "./seeDetalisModel.vue?vue&type=template&id=679b4157&scoped=true&"
import script from "./seeDetalisModel.vue?vue&type=script&lang=js&"
export * from "./seeDetalisModel.vue?vue&type=script&lang=js&"
import style0 from "./seeDetalisModel.vue?vue&type=style&index=0&id=679b4157&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b4157",
  null
  
)

export default component.exports